// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "npm.vendor--cld-video-player.min.css-0---}}" + "." + "7312239894039bf78342" + ".css";
};